export default __webpack_public_path__ + "static/media/advImg.93ccd2ce.png";